import React, { useState } from "react"
import { useSelector } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
// import Logo from "components/Logo"
import logo from "../../assets/firstline_social_logo.png"
import logoBlue from "../../assets/firstline_social_icon_logo.png"
import clsx from "clsx"
import cloudinary from "cloudinary-core"
import { Avatar, CircularProgress, Typography } from "@material-ui/core"
import noLogo from "assets/no-logo.png"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})

const Header = ({
  classes,
  whiteLabeledLogo,
  isWhiteLabeled,
  logoLoading,
  orgName
}) => {
  const isLoginPage = window.location.pathname === "/login"

  const [logoImage, setLocoImage] = useState(
    window.innerWidth < 1280 || !isLoginPage ? logo : logoBlue
  )

  return (
    <div className={clsx(classes.root, isLoginPage && classes.rootLogin)}>
      {/* <Logo /> */}
      {logoLoading ? (
        <CircularProgress />
      ) : (
        /* eslint-disable */

        <div className={clsx(classes.logo, isLoginPage && classes.logoLogin)}>
          {isWhiteLabeled === 1 && whiteLabeledLogo !== null ? (
            <Avatar
              className={classes.whiteLabeledLogo}
              src={whiteLabeledLogo}
            />
          ) : (isWhiteLabeled === 1 && whiteLabeledLogo === null) ||
            (isWhiteLabeled === 1 && whiteLabeledLogo === undefined) ? (
            <Avatar className={classes.whiteLabeledLogo} src={noLogo} />
          ) : (
            <img
              src={logoImage}
              className={clsx(classes.image, isLoginPage && classes.imageLogin)}
              alt="FirstLine Social Logo"
            />
          )}
          {isWhiteLabeled === 1 && (
            <Typography
              variant="h2"
              className={classes.orgName}
              color="primary"
            >
              {orgName}
            </Typography>
            /* eslint-enable */
          )}
        </div>
      )}
      {/* <Typography
        className={clsx(
          classes.headerText,
          isLoginPage && classes.headerTextLogin
        )}
        color="primary"
        variant="body2"
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur sit
        amet luctus nunc, vitae pharetra ex.
      </Typography> */}
      {/* <div className={clsx(classes.point, isLoginPage && classes.pointLogin)} /> */}
    </div>
  )
}

export default withStyles(styles)(Header)



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx